import { RootState } from '@/shared/store'
import { createSelector } from '@reduxjs/toolkit'

import { runsheetsAdapter } from '../adapters/runsheetsAdapter'
import { runsheetShiftsSelectors } from './runsheetShiftsSelectors'

export const runsheetsSelectors = runsheetsAdapter.getSelectors<RootState>(
  (state) => state.runsheets,
)

// Custom selectors that merge runsheets with their shifts
export const selectAllRunsheetsWithShifts = createSelector(
  [(state: RootState) => state.userInterface.activeGroupId, runsheetsSelectors.selectAll, runsheetShiftsSelectors.selectAll],
  (activeGroupId, runsheets, shifts) => {
    return runsheets
      .filter(runsheet => runsheet.groupId === activeGroupId)
      .sort((a, b) => b.name.localeCompare(a.name))
      .map(runsheet => ({
        ...runsheet,
        shifts: shifts.filter(shift => shift.runsheetId === runsheet.id),
      }))
  },
)

export const selectActiveRunsheetsWithShifts = createSelector(
  [(state: RootState) => state.userInterface.activeGroupId, runsheetsSelectors.selectAll, runsheetShiftsSelectors.selectAll],
  (activeGroupId, runsheets, shifts) => {
    return runsheets
      .filter(runsheet => !runsheet.closedOn && runsheet.groupId === activeGroupId)
      .sort((a, b) =>  b.name.localeCompare(a.name))
      .map(runsheet => ({
        ...runsheet,
        shifts: shifts.filter(shift => shift.runsheetId === runsheet.id),
      }))
  },
)

// Retreive closed runsheets with their shifts
export const selectHistoricalRunsheetsWithShifts = createSelector(
  [(state: RootState) => state.userInterface.activeGroupId, runsheetsSelectors.selectAll, runsheetShiftsSelectors.selectAll],
  (activeGroupId, runsheets, shifts) => {
    return runsheets
      .filter(runsheet => runsheet.closedOn !== undefined && runsheet.groupId === activeGroupId)
      .sort((a, b) => b.displayOrder - a.displayOrder)
      .map(runsheet => ({
        ...runsheet,
        shifts: shifts.filter(shift => shift.runsheetId === runsheet.id),
      }))
  },
)

export const selectRunsheetWithShiftsById = createSelector(
  [runsheetsSelectors.selectById, runsheetShiftsSelectors.selectAll, (_, runsheetId) => runsheetId],
  (runsheet, shifts, runsheetId) => {
    if (!runsheet) return undefined // Return undefined if the runsheet does not exist

    return {
      ...runsheet,
      shifts: shifts.filter(shift => shift.runsheetId == runsheetId),
    }
  },
)

